module.exports = __webpack_public_path__ + "assets/img/26817eca2df7bca9a53aff7660b8c8b5.png";